export enum TABS_THEME {
    DENSE = 'dense',
    SPARSE = 'sparse',
    ROUNDED = 'rounded',
}
